// import React, { useState, useEffect, useRef, useCallback } from "react";
// import logo from "../../images/logo2.svg";
// import Popup from "./Popup";
// import axios from "axios";

// import prescription from "../../images/prescription.png";
// import { Link } from "react-router-dom";
// import {
//   FaUser,
//   FaShoppingBag,
//   FaWallet,
//   FaBell,
//   FaSignOutAlt,
//   FaShoppingCart,
//   FaHeart,
// } from "react-icons/fa";
// import LoginUser from "../../images/LoginUser.png";
// import { FaHistory } from "react-icons/fa";
// import user from "../../images/user.svg";
// import login from "../../images/login.svg";
// import cart from "../../images/cart.svg";
// import wallet from "../../images/wallet.svg";
// import { useCart } from "../../Context/Createcontext";
// import { useApp } from "../../Context/AppContext";
// import { useWishlist } from "../../Context/WishlistContext";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { api_url } from "../../config/config";
// const Navbar = () => {
//   const { contextConcerns } = useApp();
//   const [showConcerns, setShowConcerns] = useState(false);
//   const navigate = useNavigate();
//   const { cartCount, handleLogout } = useCart();
//   const { wishlistCount } = useWishlist();
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const desktopDropdownRef = useRef(null);
//   const mobileDropdownRef = useRef(null);
//   const [showResults, setShowResults] = useState(false);
//   const [isPopupOpen, setPopupOpen] = useState(false);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [query, setQuery] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [prescriptionFile, setPrescriptionFile] = useState(null);
//   const [prescriptionNotes, setPrescriptionNotes] = useState("");
//   const handlestoresearchproduct = (product_id, product) => {
//     navigate(`/products/${product.name?.toLowerCase().replace(/\s+/g, "-")}`, {
//       state: { product_id },
//     });
//   };
//   const toggleDropdown = () => {
//     setIsDropdownOpen((prev) => !prev);
//   };

//   useEffect(() => {
//     const checkLogin = () => {
//       const token = localStorage.getItem("authToken");
//       setIsLoggedIn(!!token);
//     };

//     checkLogin(); // run on mount

//     window.addEventListener("authChanged", checkLogin); // listen for login

//     return () => window.removeEventListener("authChanged", checkLogin); // Set state based on token existence
//   }, []);
//   // Debounce function
//   const debounce = (func, delay) => {
//     let timer;
//     return (...args) => {
//       clearTimeout(timer);
//       timer = setTimeout(() => func(...args), delay);
//     };
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         desktopDropdownRef.current &&
//         !desktopDropdownRef.current.contains(event.target) &&
//         mobileDropdownRef.current &&
//         !mobileDropdownRef.current.contains(event.target) &&
//         !event.target.closest(".dropdown-link") // 🔥 Ensures links inside dropdown are clickable
//       ) {
//         setIsDropdownOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const fetchResults = async (query) => {
//     if (!query.trim()) {
//       setSearchResults([]);
//       setShowResults(false); // Close dropdown only if query is empty
//       return;
//     }

//     setLoading(true);
//     setError(null);

//     try {
//       const response = await axios.get(
//         `${api_url}/products-search?query=${query}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             "x-auth": "false",
//           },
//         },
//       );

//       let results = response.data.data || [];

//       if (Array.isArray(results)) {
//         results = results.filter((product) =>
//           product.name.toLowerCase().includes(query.toLowerCase()),
//         );

//         setSearchResults(results);
//         setShowResults(true); // ✅ Keep dropdown open

//         if (results.length === 0) {
//           setSearchResults([]); // ✅ Show "No Products Found" properly
//         }
//       } else {
//         setSearchResults([]);
//         setShowResults(true); // ✅ Keep dropdown open even if no results
//       }
//     } catch (err) {
//       console.error("API error:", err.message);
//       setError("Failed to fetch products. Please try again later.");
//       setSearchResults([]);
//       setShowResults(true); // ✅ Ensure dropdown stays open on error
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Debounced search function
//   const handleSearch = useCallback(
//     debounce((e) => {
//       const query = e.target.value;
//       setSearchQuery(query); // Update input state
//       fetchResults(query);
//     }, 300),
//     [],
//   );
//   const handleInputChange = (e) => {
//     const searchQuery = e.target.value;
//     setQuery(searchQuery);
//     setShowResults(true); // ✅ Ensure dropdown stays open
//     fetchResults(searchQuery);
//   };

//   const logoutUser = () => {
//     localStorage.removeItem("authToken");
//     window.dispatchEvent(new Event("authChanged"));
//     handleLogout();
//     setIsLoggedIn(false);
//     toast.success("Logged out successfully");
//     navigate("/home");
//   };
//   const handleProductClick = (product) => {
//     console.log("Product clicked:", product);
//     setSearchResults([]); // Clear search results
//     setSearchQuery(""); // Clear search input
//     setShowResults(false); // Close the dropdown
//   };
//   const togglePopup = () => {
//     setPopupOpen(!isPopupOpen);
//   };

//   // Function to open sidebar
//   const openSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   // Function to close sidebar
//   const closeSidebar = () => {
//     setIsSidebarOpen(false);
//   };

//   const fileInputRef = useRef(null);

//   const handleClick = () => {
//     const getToken = localStorage.getItem("authToken");
//     if (!getToken) {
//       toast.error("Please log in before uploading a prescription.");
//       return;
//     }
//     setShowModal(true);
//   };

//   const handleUploadPrescriptionClick = (e) => {
//     if (!isLoggedIn) {
//       e.preventDefault();
//       toast.error("Please log in before uploading a prescription.");
//     }
//   };

//   useEffect(() => {
//     const token = localStorage.getItem("authToken");
//     setIsLoggedIn(!!token);
//   }, []);

//   const handleDropdownClick = (e, path, state) => {
//     e.stopPropagation();
//     setIsDropdownOpen(false);
//     setTimeout(() => {
//       navigate(path, { state });
//     }, 100);
//   };

//   return (
//     <nav>
//       {/* desktop screen  */}
//       <div className=" invisible flex items-center justify-between p-7 bg-[#162C2A] text-white w-full h-[110px] z-[1000] fixed top-0 left-0 lg:visible">
//         <div className="flex items-center">
//           <a href="/home">
//             <img
//               src={logo}
//               alt="Logo"
//               className="lg:h-[95px] h-[85px] lg:w-[225px]  w-[225px]   mt-[12px]"
//             />
//           </a>
//         </div>

//         <div className="flex items-center justify-evenly gap-7 lg:visible">
//           <div className="flex flex-col items-center relative">
//             {/* Search Input */}
//             <div className="flex items-center justify-between rounded-full border border-[#162C2A] bg-white px-3 flex-grow h-10 lg:h-[50px] lg:w-[250px]">
//               <input
//                 type="text"
//                 value={query}
//                 onChange={handleInputChange}
//                 placeholder="Search Products"
//                 className="text-sm font-normal font-poppins text-[#848484] w-full outline-none"
//               />
//               <svg
//                 width="16"
//                 height="18"
//                 viewBox="0 0 16 16"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="text-[#162C2A]"
//               >
//                 <path
//                   d="M7.4349 15.0989C9.30942 15.0989 11.022 14.4001 12.3305 13.2517L14.8651 15.59C14.9953 15.7097 15.1599 15.7704 15.3227 15.7704C15.5049 15.7704 15.6853 15.6982 15.8208 15.5522C16.0734 15.2776 16.0576 14.849 15.7821 14.5973L13.2633 12.2714C14.2674 11.0032 14.8694 9.40336 14.8694 7.66432C14.8694 3.56419 11.5348 0.229614 7.4347 0.229614C3.33458 0.229614 0 3.56419 0 7.66432C0 11.7644 3.33458 15.099 7.4347 15.099L7.4349 15.0989ZM7.4349 1.58126C10.7898 1.58126 13.5178 4.30934 13.5178 7.6642C13.5178 11.0191 10.7898 13.7471 7.4349 13.7471C4.08005 13.7471 1.35196 11.0191 1.35196 7.6642C1.35196 4.30934 4.08005 1.58126 7.4349 1.58126Z"
//                   fill="#162C2A"
//                 />
//               </svg>
//             </div>

//             {/* Search Results */}
//             {showResults && (
//               <div className="absolute mt-2 w-full max-w-[350px] bg-white border border-[#162C2A] rounded-lg shadow-lg z-10 mt-[80px]">
//                 <div className="max-h-[400px] overflow-y-auto">
//                   {loading ? (
//                     <div className="text-center p-2">Loading...</div>
//                   ) : error ? (
//                     <div className="text-center text-red-500 p-2">{error}</div>
//                   ) : searchResults.length > 0 ? (
//                     searchResults.map((product, index) => (
//                       <Link
//                         key={index}
//                         to="#"
//                         onClick={(e) => {
//                           e.preventDefault();
//                           handlestoresearchproduct(product.product_id, product);
//                           setTimeout(() => {
//                             setShowResults(false); // Hide dropdown after delay
//                             // setQuery(""); // Clear input
//                           }, 100);
//                         }}
//                       >
//                         <div className="p-3 border-b border-[#f1f1f1] hover:bg-[#f0f0f0] cursor-pointer flex items-center space-x-3">
//                           <img
//                             src={
//                               product?.product_images?.image_url
//                                 ?.primary_image || "/default.svg"
//                             }
//                             alt={product?.name || "Product"}
//                             onError={(e) => {
//                               e.target.onerror = null;
//                               e.target.src = "/default.svg";
//                             }}
//                             className="w-8 h-8 object-cover rounded"
//                           />
//                           <h4 className="text-sm font-semibold text-black">
//                             {product?.name}
//                           </h4>
//                         </div>
//                       </Link>
//                     ))
//                   ) : (
//                     <div className="p-3 text-gray-500 text-center">
//                       No Products Found
//                     </div>
//                     // ✅ Fix: "No Products Found" now properly appears
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* upload Prescription part desktop start*/}
//           <div
//             id="upload-link"
//             className="flex items-center justify-start bg-white text-[#162c2a] rounded-full px-2 py-3 cursor-pointer mx-2 max-w-[240px] min-h-[40px]"
//           >
//             <Link
//               to="/my-prescriptions"
//               onClick={handleUploadPrescriptionClick}
//               className="flex items-center whitespace-nowrap ml-4 gap-2 mr-4"
//             >
//               <img src={prescription} alt="prescription" className="w-4 h-4" />
//               <span className="text-[#162C2A] text-[16px] leading-[24px] -ml-[5px] font-normal font-poppins">
//                 Upload Prescription
//               </span>
//             </Link>

//             {/* <input
//               type="file"
//               ref={fileInputRef}
//               style={{ display: "none" }}
//               onChange={handleFileChange}
//             /> */}
//           </div>
//           {/* upload Prescription part desktop end*/}
//           <div className="relative group">
//             <Link
//               to="#"
//               onClick={(e) => {
//                 e.preventDefault();
//                 if (isLoggedIn) {
//                   navigate("/wishlist");
//                 } else {
//                   toast.error("Please log in before accessing wishlist");
//                 }
//               }}
//             >
//               <div
//                 id="favorites-link"
//                 className="relative bg-gray-200 text-gray-500 h-10 w-10 rounded-lg flex items-center justify-center hover:bg-gray-300 transition-colors"
//               >
//                 <svg
//                   width="24"
//                   height="22"
//                   viewBox="0 0 24 22"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M6.38614 0C4.74261 0 3.09914 0.643735 1.85902 1.94157C-0.621273 4.5372 -0.618074 8.69647 1.85902 11.2938L11.3266 21.2228C11.4128 21.3132 11.5164 21.3852 11.6312 21.4344C11.7461 21.4836 11.8697 21.5089 11.9946 21.5089C12.1195 21.5089 12.2431 21.4836 12.358 21.4344C12.4728 21.3852 12.5765 21.3132 12.6626 21.2228C15.8209 17.9176 18.9815 14.6086 22.1398 11.3034C24.6201 8.70776 24.6201 4.54686 22.1398 1.95119C19.6596 -0.644474 15.5658 -0.644529 13.0856 1.95119L11.9994 3.07576L10.9133 1.94157C9.67315 0.643742 8.02968 0 6.38614 0ZM6.38614 1.80701C7.53343 1.80701 8.68851 2.27978 9.58687 3.21994L11.3362 5.05578C11.4224 5.14621 11.526 5.21821 11.6409 5.26739C11.7557 5.31658 11.8793 5.34192 12.0042 5.34192C12.1291 5.34192 12.2528 5.31658 12.3676 5.26739C12.4824 5.21821 12.586 5.14621 12.6722 5.05578L14.412 3.22955C16.2087 1.3492 19.0071 1.34924 20.8038 3.22955C22.6005 5.10985 22.6005 8.15436 20.8038 10.0347C17.8694 13.1056 14.9337 16.1719 11.9994 19.2427L3.19504 10.0251C1.39058 8.14854 1.39058 4.68359 3.19504 2.80701C4.09127 1.87063 5.2389 1.39889 6.38614 1.80701Z"
//                     fill="#162C2A"
//                   />
//                 </svg>
//                 {wishlistCount > 0 && (
//                   <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
//                     {wishlistCount}
//                   </span>
//                 )}
//               </div>
//             </Link>
//             <span className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute top-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-[#162C2A] rounded whitespace-nowrap">
//               Wishlist
//             </span>
//           </div>
//           <div className="relative group">
//             <Link
//               to="#"
//               className="relative flex items-center justify-center w-10 h-10 bg-white text-gray-400 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
//               onClick={(e) => {
//                 e.preventDefault();
//                 if (isLoggedIn) {
//                   navigate("/cart");
//                 } else {
//                   toast.error("Please log in before accessing the cart.");
//                 }
//               }}
//             >
//               <img src={cart} alt="Cart" className="w-10 h-10" />

//               {/* Cart count badge */}
//               {cartCount > 0 && (
//                 <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
//                   {cartCount}
//                 </span>
//               )}
//             </Link>
//             <span className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute top-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-[#162C2A] rounded whitespace-nowrap">
//               Cart
//             </span>
//           </div>
//           <div className={`relative ${isLoggedIn ? "group" : ""}`}>
//             <div
//               id="login"
//               className="cursor-pointer relative h-[40px] rounded-[10px] flex items-center justify-center"
//               onClick={(e) => {
//                 if (!e.target.closest(".dropdown-link")) {
//                   e.stopPropagation();
//                   if (isLoggedIn) {
//                     setIsDropdownOpen((prev) => !prev);
//                   } else {
//                     togglePopup();
//                   }
//                 }
//               }}
//             >
//               <img
//                 src={isLoggedIn ? user : login}
//                 alt="User"
//                 className={
//                   isLoggedIn
//                     ? "hidden md:block md:w-[40px] md:h-[40px] w-10 h-10 hover:opacity-90 transition-opacity"
//                     : "hidden md:block md:w-[85px] md:h-[40px] w-10 h-10"
//                 }
//               />
//             </div>
//             {isLoggedIn && (
//               <span className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute top-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-[#162C2A] rounded whitespace-nowrap">
//                 My Account
//               </span>
//             )}
//             {isLoggedIn && isDropdownOpen && (
//               <div
//                 ref={desktopDropdownRef}
//                 className="absolute top-full right-0 bg-white shadow-md rounded-lg mt-2 w-56 p-2 z-50"
//               >
//                 <Link
//                   to="/profilepage"
//                   state={{ scrollTo: "profile" }} // Pass scrollTo state
//                   className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                   onClick={() => setIsDropdownOpen(false)}
//                 >
//                   <FaUser className="text-gray-500" />
//                   <span className="text-sm">My Profile</span>
//                 </Link>

//                 <Link
//                   to="/my-orders"
//                   className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                   onClick={() => setIsDropdownOpen(false)}
//                 >
//                   <FaShoppingBag className="text-gray-500" />
//                   <span className="text-sm">My Orders</span>
//                 </Link>
//                 {/* <Link
//                   to="/profilepage"
//                   state={{ scrollTo: "wallet" }} // Pass scrollTo state
//                   className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                 >
//                   <FaWallet className="text-gray-500" />
//                   <span className="text-sm">Point Wallet</span>
//                 </Link> */}
//                 <Link
//                   to="/my-prescriptions"
//                   className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                   onClick={() => setIsDropdownOpen(false)}
//                 >
//                   <img
//                     src={prescription}
//                     alt="Prescription"
//                     className="w-4 h-4"
//                   />
//                   <span className="text-sm">My Prescriptions</span>
//                 </Link>
//                 <Link
//                   to="/my-transactions"
//                   className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                   onClick={() => setIsDropdownOpen(false)}
//                 >
//                   <FaHistory className="text-gray-500" />
//                   <span className="text-sm">My Transactions</span>
//                 </Link>
//                 <Link
//                   to="/cart"
//                   className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                   onClick={() => setIsDropdownOpen(false)}
//                 >
//                   <FaShoppingCart className="text-gray-500" />
//                   <span className="text-sm">My Cart</span>
//                 </Link>
//                 <Link
//                   to="/wishlist"
//                   className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                   onClick={() => setIsDropdownOpen(false)}
//                 >
//                   <FaHeart className="text-gray-500" />
//                   <span className="text-sm">My Wishlist</span>
//                 </Link>
//                 {/* <Link
//            to="/notification"
//            className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//          >
//            <FaBell className="text-gray-500 relative" />
//            <span className="text-sm">Notifications</span>
//          </Link> */}
//                 <div
//                   className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                   onClick={logoutUser}
//                 >
//                   <FaSignOutAlt className="text-gray-500" />
//                   <span className="text-sm">Log Out</span>
//                 </div>
//               </div>
//             )}
//           </div>

//           <div className="marquee-content absolute top-0 w-full mt-1">
//             Free Home Delivery{" "}
//           </div>
//         </div>
//       </div>

//       {isPopupOpen && <Popup onClose={togglePopup} />}

//       {/* mobile responsive item */}

//       <div
//         className=" flex flex-col items-center justify-between p-2
//        bg-[#162C2A] text-white h-36 top-0 left-0 w-full z-50 lg:hidden fixed md:h-[100px]"
//       >
//         {/* Upper Section: Logo, Login, Toggle Button */}

//         <div className="flex items-center justify-between w-full px-2 sm:px-3 md:px-3 py-2 ">
//           <div className="marquee-content absolute left-0 top-0 w-full text-center text-white text-sm py-2">
//             Free Home Delivery
//           </div>
//           {/* Logo */}
//           <a href="/home">
//             <img
//               src={logo}
//               alt="Logo"
//               className="h-[54px] w-[130px] sm:h-[64px] sm:w-[150px] md:w-[150px] md:h-[65px]
//           md:-ml-[20px]"
//             />
//           </a>
//           <div className="flex items-center gap-3 md:gap-2">
//             <Link
//               to="#"
//               className="relative flex z-10 items-center justify-center w-[26px] h-[26px] bg-white text-gray-400 rounded-lg cursor-pointer"
//               onClick={(e) => {
//                 e.preventDefault();
//                 if (isLoggedIn) {
//                   navigate("/cart");
//                 } else {
//                   toast.error("Please log in before accessing the cart.");
//                 }
//               }}
//             >
//               <img src={cart} alt="Cart" className="w-7 h-7" />

//               {cartCount > 0 && (
//                 <span className="absolute -top-1 lg:-top-2 -right-2 bg-red-500 text-white text-[10px] lg:text-[12px] font-[500] w-[14px] h-[14px] lg:w-4 lg:h-4 flex items-center justify-center rounded-full">
//                   {cartCount}
//                 </span>
//               )}
//             </Link>
//             <div
//               id="login-link"
//               className="w-[90px] h-[40px] top-[29px] cursor-pointer rounded-[10px] font-poppins leading-10 font-medium flex items-center justify-center relative -mt-[60px] -ml-3 mr-6"
//               onClick={isLoggedIn ? toggleDropdown : togglePopup}
//             >
//               {isLoggedIn ? (
//                 <img
//                   src={user}
//                   alt="User"
//                   className="w-[27px] h-8 lg:w-14 lg:h-14 -ml-2"
//                 />
//               ) : (
//                 <button className="flex items-center justify-center w-[60px] gap-1 h-7 lg:w-14 lg:h-14 -ml-2 bg-gray-100 rounded-md border border-gray-300 hover:bg-gray-200 transition">
//                   <img src={LoginUser} alt="Login Icon" className="w-3 h-3" />
//                   <span className="text-[12px] font-medium font-Poppins text-[#162C2A]">
//                     Login
//                   </span>
//                 </button>
//               )}

//               {/* Dropdown (unchanged) */}
//               {isLoggedIn && isDropdownOpen && (
//                 <div
//                   ref={mobileDropdownRef}
//                   className="absolute top-full right-0 bg-white shadow-md rounded-lg mt-2 w-56 p-2 z-50 -mr-[20px]"
//                 >
//                   <div
//                     className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                     onClick={(e) =>
//                       handleDropdownClick(e, "/profilepage", {
//                         scrollTo: "profile",
//                       })
//                     }
//                   >
//                     <FaUser className="text-gray-500" />
//                     <span className="text-sm">My Profile</span>
//                   </div>

//                   <Link
//                     to="/my-orders"
//                     className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                     onClick={() => setIsDropdownOpen(false)}
//                   >
//                     <FaShoppingBag className="text-gray-500" />
//                     <span className="text-sm">My Orders</span>
//                   </Link>

//                   <Link
//                     to="/my-prescriptions"
//                     className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                   >
//                     <img
//                       src={prescription}
//                       alt="Prescription"
//                       className="w-4 h-4"
//                     />
//                     <span className="text-sm">My Prescriptions</span>
//                   </Link>
//                   <Link
//                     to="/my-transactions"
//                     className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                     onClick={() => setIsDropdownOpen(false)}
//                   >
//                     <FaHistory className="text-gray-500" />
//                     <span className="text-sm">My Transactions</span>
//                   </Link>
//                   <Link
//                     to="/cart"
//                     className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                     onClick={() => setIsDropdownOpen(false)}
//                   >
//                     <FaShoppingCart className="text-gray-500" />
//                     <span className="text-sm">My Cart</span>
//                   </Link>
//                   <Link
//                     to="#"
//                     onClick={(e) => {
//                       e.preventDefault();
//                       if (isLoggedIn) {
//                         navigate("/profilepage");
//                       } else {
//                         toast.error("Please log in before accessing wishlist");
//                       }
//                     }}
//                     className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                   >
//                     <FaHeart className="text-gray-500" />
//                     <span className="text-sm">My Wishlist</span>
//                   </Link>

//                   <div
//                     className="flex items-center gap-2 p-2 hover:bg-gray-100 cursor-pointer rounded-md text-black border-b-2 border-gray-100"
//                     onClick={logoutUser}
//                   >
//                     <FaSignOutAlt className="text-gray-500" />
//                     <span className="text-sm">Log Out</span>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Toggle Button */}
//           <div
//             className="block md:block lg:hidden  cursor-pointer"
//             onClick={openSidebar}
//             style={{
//               position: "absolute",
//               right: "20px",
//             }}
//           >
//             <svg
//               width="35px"
//               height="45px"
//               viewBox="0 0 32 32"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 d="M5.71429 6C4.76751 6 4 6.76748 4 7.71429C4 8.66103 4.76751 9.42857 5.71429 9.42857H26.2857C27.2325 9.42857 28 8.66103 28 7.71429C28 6.76748 27.2325 6 26.2857 6H5.71429ZM5.71429 14C4.76751 14 4 14.7675 4 15.7143C4 16.661 4.76751 17.4286 5.71429 17.4286H26.2857C27.2325 17.4286 28 16.661 28 15.7143C28 14.7675 27.2325 14 26.2857 14H5.71429ZM5.71429 22C4.76751 22 4 22.7675 4 23.7143C4 24.661 4.76751 25.4286 5.71429 25.4286H26.2857C27.2325 25.4286 28 24.661 28 23.7143C28 22.7675 27.2325 22 26.2857 22H5.71429Z"
//                 fill="white"
//               />
//             </svg>
//           </div>
//         </div>

//         {/* Lower Section: Search Bar and Upload Icon */}
//         <div className="flex items-center w-full md:w-[250px] md:mt-[10px] md:-ml-[260px] md:absolute space-x-4 px-3 py-2">
//           <div className="w-[280px]">
//             {/* Search Input */}
//             <div className="flex items-center justify-between rounded-full border border-[#162C2A] bg-white px-3 flex-grow h-10">
//               <input
//                 type="text"
//                 value={query}
//                 onChange={handleInputChange}
//                 placeholder="Search Products"
//                 className="text-sm font-normal font-poppins text-[#848484] w-full outline-none"
//               />
//               <svg
//                 width="16"
//                 height="18"
//                 viewBox="0 0 16 16"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="text-[#162C2A]"
//               >
//                 <path
//                   d="M7.4349 15.0989C9.30942 15.0989 11.022 14.4001 12.3305 13.2517L14.8651 15.59C14.9953 15.7097 15.1599 15.7704 15.3227 15.7704C15.5049 15.7704 15.6853 15.6982 15.8208 15.5522C16.0734 15.2776 16.0576 14.849 15.7821 14.5973L13.2633 12.2714C14.2674 11.0032 14.8694 9.40336 14.8694 7.66432C14.8694 3.56419 11.5348 0.229614 7.4347 0.229614C3.33458 0.229614 0 3.56419 0 7.66432C0 11.7644 3.33458 15.099 7.4347 15.099L7.4349 15.0989ZM7.4349 1.58126C10.7898 1.58126 13.5178 4.30934 13.5178 7.6642C13.5178 11.0191 10.7898 13.7471 7.4349 13.7471C4.08005 13.7471 1.35196 11.0191 1.35196 7.6642C1.35196 4.30934 4.08005 1.58126 7.4349 1.58126Z"
//                   fill="#162C2A"
//                 />
//               </svg>
//             </div>

//             {/* Search Results */}
//             {showResults && (
//               <div className="absolute mt-2 w-[70%] max-w-[350px] bg-white border border-[#162C2A] rounded-lg shadow-lg z-10">
//                 <div className="max-h-[400px] overflow-y-auto">
//                   {loading ? (
//                     <div className="text-center p-2">Loading...</div>
//                   ) : error ? (
//                     <div className="text-center text-red-500 p-2">{error}</div>
//                   ) : searchResults.length > 0 ? (
//                     searchResults.map((product, index) => (
//                       <Link
//                         key={index}
//                         to="#"
//                         onClick={(e) => {
//                           e.preventDefault();
//                           handlestoresearchproduct(product.product_id, product);
//                           setTimeout(() => {
//                             setShowResults(false); // Hide dropdown after delay
//                             setQuery(""); // Clear input
//                           }, 100);
//                         }}
//                       >
//                         <div className="p-3 border-b border-[#f1f1f1] hover:bg-[#f0f0f0] cursor-pointer flex items-center space-x-3">
//                           <img
//                             src={
//                               product?.product_images?.image_url?.primary_image
//                             }
//                             alt={product.name}
//                             className="w-6 h-6 object-cover rounded"
//                           />
//                           <h4 className="text-sm font-semibold text-black">
//                             {product.name}
//                           </h4>
//                         </div>
//                       </Link>
//                     ))
//                   ) : (
//                     <div className="p-3 text-gray-500 text-center">
//                       No Products Found
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Upload Icon */}

//           <div id="upload-link" className="md:hidden">
//             <Link
//               to="/my-prescriptions"
//               onClick={handleUploadPrescriptionClick}
//               className="md:hidden visible flex items-center justify-start text-[#162c2a] rounded-full px-2 py-2 cursor-pointer -mt-4"
//             ></Link>
//             <svg
//               width="22"
//               height="22"
//               viewBox="0 0 24 21"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//               className="text-white cursor-pointer"
//             >
//               <path
//                 d="M22.9414 10.4108C22.3555 10.4108 21.8826 10.8836 21.8826 11.4696V16.4317C21.8826 17.7828 20.781 18.8816 19.4327 18.8816H4.56762C3.21926 18.8816 2.11768 17.78 2.11768 16.4317V11.4696C2.11768 10.8836 1.6448 10.4108 1.05884 10.4108C0.472878 10.4108 0 10.8836 0 11.4696V16.4317C0 18.9492 2.05012 20.9992 4.56748 20.9992H19.4297C21.9499 20.9992 24 18.949 24 16.4317V11.4696C24 10.8836 23.5274 10.4108 22.9414 10.4108Z"
//                 fill="white"
//               />
//               <path
//                 d="M13.0578 3.61217L17.2504 7.80482C17.4558 8.01438 17.7275 8.1164 17.9991 8.1164C18.2706 8.1164 18.5423 8.01438 18.7477 7.80619C19.1613 7.39258 19.1613 6.72254 18.7477 6.3103L12.7476 0.310213C12.334 -0.103404 11.6639 -0.103404 11.2517 0.310213L5.25162 6.3103C4.838 6.72392 4.838 7.39395 5.25162 7.80619C5.66524 8.21981 6.33527 8.21981 6.74751 7.80619L10.9402 3.61213V14.4695C10.9402 15.0554 11.413 15.5283 11.999 15.5283C12.585 15.5283 13.0578 15.0554 13.0578 14.4695L13.0578 3.61217Z"
//                 fill="white"
//               />
//             </svg>
//           </div>
//           <div className="md:hidden">
//             {isLoggedIn && (
//               <Link
//                 to="/my-orders"
//                 onClick={() => {
//                   closeSidebar();
//                 }}
//                 className="whitespace-nowrap text-sm font-medium text-white px-3 py-2 shadow-md"
//               >
//                 Quick Order
//               </Link>
//             )}
//           </div>
//         </div>
//         <div
//           id="upload-link"
//           className="md:absolute invisible md:visible items-center justify-start bg-white text-[#162c2a] rounded-full px-2 py-3 cursor-pointer mx-2 min-w-[200px] min-h-[30px]  md:ml-[230px] md:mt-[20px] md:h-[40px]"
//         >
//           <Link
//             to="/my-prescriptions"
//             onClick={handleUploadPrescriptionClick}
//             className="flex items-center whitespace-nowrap ml-4 gap-2"
//           >
//             <img src={prescription} alt="prescription" className="w-4 h-4" />
//             <span
//               className="text-[#162C2A] text-[16px] leading-[24px] font-normal font-poppins
//               md:-mt-[5px]"
//             >
//               Upload Prescription
//             </span>
//           </Link>
//           {/* <input
//             type="file"
//             ref={fileInputRef}
//             style={{ display: "none" }}
//             onChange={handleFileChange}
//           /> */}
//         </div>
//       </div>

//       {isSidebarOpen && (
//         <div className="fixed top-0 right-0 z-[10000] sidebar bg-[#162c2a] text-white h-full w-[65%]">
//           {/* Close Button */}
//           <div className="absolute top-5 right-5" onClick={closeSidebar}>
//             <svg
//               width="24"
//               height="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//               className="flex justify-end"
//             >
//               <path
//                 d="M16.1657 12.0029L23.1361 5.03259C24.288 3.88068 24.288 2.01584 23.1361 0.866875C21.9842 -0.282084 20.1193 -0.282084 18.9704 0.866875L12 7.83723L5.02964 0.863929C3.87774 -0.287976 2.01289 -0.287976 0.863929 0.863929C-0.28503 2.01583 -0.28503 3.88068 0.863929 5.02964L7.83428 12L0.863929 18.9704C-0.287976 20.1223 -0.287976 21.9871 0.863929 23.1361C2.01583 24.285 3.88068 24.285 5.02964 23.1361L12 16.1657L18.9704 23.1361C20.1223 24.288 21.9871 24.288 23.1361 23.1361C24.285 21.9842 24.285 20.1193 23.1361 18.9704L16.1657 12V12.0029Z"
//                 fill="white"
//               />
//             </svg>
//           </div>

//           {/* Sidebar Menu */}
//           <ul className="py-6 mt-16 ml-6 space-y-5">
//             <li className="font-poppins font-normal text-[16px]">
//               <Link to="/home" onClick={closeSidebar}>
//                 Home
//               </Link>
//             </li>
//             <li className="font-poppins font-normal text-[16px]">
//               <Link to="/about-us" onClick={closeSidebar}>
//                 About
//               </Link>
//             </li>
//             <li className="font-poppins font-normal text-[16px]">
//               <Link to="/categories" onClick={closeSidebar}>
//                 Categories
//               </Link>
//             </li>
//             <li className="font-poppins font-normal text-[16px]">
//               <Link to="/featured-products" onClick={closeSidebar}>
//                 Featured
//               </Link>
//             </li>
//             <li className="font-poppins font-normal text-[16px]">
//               <Link to="/shopbrand" onClick={closeSidebar}>
//                 Brands
//               </Link>
//             </li>

//             <li className="font-poppins font-normal text-[16px]">
//               <button
//                 className="flex items-center w-full font-normal mb-1 focus:outline-none"
//                 onClick={() => setShowConcerns((prev) => !prev)}
//                 aria-expanded={showConcerns}
//                 aria-controls="sidebar-concerns-list"
//                 type="button"
//               >
//                 <span>Concerns</span>
//                 <svg
//                   className={`ml-2 transition-transform duration-200 ${showConcerns ? "rotate-90" : ""}`}
//                   width="16"
//                   height="16"
//                   viewBox="0 0 16 16"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M6 12L10 8L6 4"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </button>
//               {showConcerns && (
//                 <ul id="sidebar-concerns-list" className="ml-2 mt-1 space-y-1">
//                   {contextConcerns && contextConcerns.length > 0 ? (
//                     contextConcerns.map((concern) => (
//                       <li key={concern.concern_id}>
//                         <button
//                           className="text-left w-full hover:underline"
//                           onClick={() => {
//                             navigate(
//                               `/shop-by-concern/${concern.name.toLowerCase().replace(/\s+/g, "-")}`,
//                               {
//                                 state: {
//                                   concern_id: concern.concern_id,
//                                   concern_name: concern.name,
//                                 },
//                               },
//                             );
//                             closeSidebar();
//                             setShowConcerns(false);
//                           }}
//                         >
//                           {concern.name}
//                         </button>
//                       </li>
//                     ))
//                   ) : (
//                     <li className="text-gray-400">Concerns Loading...</li>
//                   )}
//                 </ul>
//               )}
//             </li>
//             <li className="font-poppins font-normal text-[16px]">
//               <Link to="/products" onClick={closeSidebar}>
//                 All Products
//               </Link>
//             </li>
//             {/* <li className="font-poppins font-normal text-[16px]">
//                 {isLoggedIn && (
//               <Link
//                 to="/profilepage"
//                 state={{ scrollTo: "myOrders" }}
//                 onClick={() => { handleQuickOrderClick(); closeSidebar(); }}>
//                 Quick Order
//               </Link>
//                 )}
//             </li> */}
//             <li className="font-poppins font-normal text-[16px]">
//               <Link
//                 to="#"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   if (isLoggedIn) {
//                     navigate("/wishlist");
//                     closeSidebar();
//                   } else {
//                     toast.error("Please log in before accessing wishlist");
//                     closeSidebar();
//                   }
//                 }}
//               >
//                 Wish List{" "}
//                 <span className="text-red-600 font-bold">
//                   ({wishlistCount})
//                 </span>
//               </Link>
//             </li>
//             {/* <li className="font-poppins font-normal text-[16px]"><Link to="/cart" onClick={closeSidebar}>Cart</Link></li> */}
//             <li className="font-poppins font-normal text-[16px]">
//               <Link to="/blogs" onClick={closeSidebar}>
//                 Wellness Guide
//               </Link>
//             </li>
//           </ul>

//           {isPopupOpen && <Popup onClose={togglePopup} />}
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navbar;
import React, { useState, useEffect, useRef, useCallback } from "react";
import logo from "../../images/logo2.svg";
import Popup from "./Popup";
import axios from "axios";
import prescription from "../../images/prescription.png";
import { Link } from "react-router-dom";
import {
  FaUser,
  FaShoppingBag,
  FaSignOutAlt,
  FaShoppingCart,
  FaHeart,
  FaPrescriptionBottleAlt,
} from "react-icons/fa";
import LoginUser from "../../images/LoginUser.png";
import { FaHistory } from "react-icons/fa";
import user from "../../images/user.svg";
import login from "../../images/login.svg";
import cart from "../../images/cart.svg";
import { useCart } from "../../Context/Createcontext";
import { useApp } from "../../Context/AppContext";
import { useWishlist } from "../../Context/WishlistContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { api_url } from "../../config/config";

const Navbar = () => {
  const { contextConcerns } = useApp();
  const [showConcerns, setShowConcerns] = useState(false);
  const navigate = useNavigate();
  const { cartCount, handleLogout } = useCart();
  const { wishlistCount } = useWishlist();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const desktopDropdownRef = useRef(null);
  const mobileDropdownRef = useRef(null);
  const [showResults, setShowResults] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  /* ── auth ── */
  useEffect(() => {
    const checkLogin = () => setIsLoggedIn(!!localStorage.getItem("authToken"));
    checkLogin();
    window.addEventListener("authChanged", checkLogin);
    return () => window.removeEventListener("authChanged", checkLogin);
  }, []);

  useEffect(() => {
    setIsLoggedIn(!!localStorage.getItem("authToken"));
  }, []);

  /* ── click outside ── */
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        desktopDropdownRef.current &&
        !desktopDropdownRef.current.contains(event.target) &&
        mobileDropdownRef.current &&
        !mobileDropdownRef.current.contains(event.target) &&
        !event.target.closest(".dropdown-link")
      ) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* ── search ── */
  const fetchResults = async (q) => {
    if (!q.trim()) {
      setSearchResults([]);
      setShowResults(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`${api_url}/products-search?query=${q}`, {
        headers: { "Content-Type": "application/json", "x-auth": "false" },
      });
      let results = res.data.data || [];
      if (Array.isArray(results)) {
        results = results.filter((p) =>
          p.name.toLowerCase().includes(q.toLowerCase()),
        );
        setSearchResults(results);
      } else {
        setSearchResults([]);
      }
      setShowResults(true);
    } catch {
      setError("Failed to fetch products. Please try again later.");
      setSearchResults([]);
      setShowResults(true);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const val = e.target.value;
    setQuery(val);
    setShowResults(true);
    fetchResults(val);
  };

  const handlestoresearchproduct = (product_id, product) => {
    navigate(`/products/${product.name?.toLowerCase().replace(/\s+/g, "-")}`, {
      state: { product_id },
    });
  };

  /* ── misc handlers ── */
  const toggleDropdown = () => setIsDropdownOpen((p) => !p);
  const togglePopup = () => setPopupOpen((p) => !p);
  const openSidebar = () => setIsSidebarOpen((p) => !p);
  const closeSidebar = () => setIsSidebarOpen(false);

  const handleUploadPrescriptionClick = (e) => {
    if (!isLoggedIn) {
      e.preventDefault();
      toast.error("Please log in before uploading a prescription.");
    }
  };

  const logoutUser = () => {
    localStorage.removeItem("authToken");
    window.dispatchEvent(new Event("authChanged"));
    handleLogout();
    setIsLoggedIn(false);
    toast.success("Logged out successfully");
    navigate("/home");
  };

  const handleDropdownClick = (e, path, state) => {
    e.stopPropagation();
    setIsDropdownOpen(false);
    setTimeout(() => navigate(path, { state }), 100);
  };

  /* ────────────────────────────────────────────────────────────
     SUB-COMPONENTS
  ──────────────────────────────────────────────────────────── */

  /**
   * TickerBar
   * Animation class `marquee-content` lives in global CSS only.
   * Everything else is Tailwind.
   */
  const TickerBar = () => (
    <div className="w-full h-7 bg-[#1e4a46] overflow-hidden flex items-center">
      <span className="marquee-content text-[11px] font-medium text-white/85 tracking-wide flex items-center gap-2 font-poppins">
        <span className="mx-10 w-1.5 h-1.5 rounded-full bg-[#ff601e] inline-block" />
        Free Home Delivery
        <span className="mx-10 w-1.5 h-1.5 rounded-full bg-[#ff601e] inline-block" />
        Free Home Delivery
        <span className="mx-10 w-1.5 h-1.5 rounded-full bg-[#ff601e] inline-block" />
        Free Home Delivery{" "}
        <span className="mx-10 w-1.5 h-1.5 rounded-full bg-[#ff601e] inline-block" />
      </span>
    </div>
  );

  /**
   * SearchDropdown
   * `custom-scrollbar` class → brand teal scrollbar, defined in global CSS.
   * Everything else is Tailwind.
   */
  const SearchDropdown = ({ isMobile }) => (
    <div
      className={`absolute top-[calc(100%+8px)] left-0 ${
        isMobile ? "w-[90vw] max-w-[340px]" : "w-full min-w-[300px]"
      } bg-white border border-[#d4ecea] rounded-2xl shadow-2xl z-[200] overflow-hidden`}
    >
      {/* custom-scrollbar → teal branded scrollbar from global CSS */}
      <div className="max-h-[360px] overflow-y-auto custom-scrollbar">
        {loading ? (
          <p className="py-5 text-center text-[13px] text-[#8faba9] font-poppins">
            Searching…
          </p>
        ) : error ? (
          <p className="py-5 text-center text-[13px] text-red-500 font-poppins">
            {error}
          </p>
        ) : searchResults.length > 0 ? (
          searchResults.map((product, i) => (
            <Link
              key={i}
              to="#"
              onClick={(e) => {
                e.preventDefault();
                handlestoresearchproduct(product.product_id, product);
                setTimeout(() => {
                  setShowResults(false);
                  setQuery("");
                }, 100);
              }}
              className="flex items-center gap-3 px-4 py-3 border-b border-[#f1f5f5] last:border-b-0 hover:bg-[#eaf4f3] transition-colors duration-150 cursor-pointer"
            >
              <img
                src={
                  product?.product_images?.image_url?.primary_image ||
                  "/default.svg"
                }
                alt={product?.name || "Product"}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/default.svg";
                }}
                className="w-9 h-9 object-cover rounded-lg border border-[#e2eaea] flex-shrink-0"
              />
              <span className="text-[13px] font-semibold text-[#1e4a46] font-poppins truncate">
                {product?.name}
              </span>
            </Link>
          ))
        ) : (
          <p className="py-6 text-center text-[13px] text-[#8faba9] font-poppins">
            No products found
          </p>
        )}
      </div>
    </div>
  );

  /**
   * DropdownMenu — account menu shared by desktop + mobile.
   * Pure Tailwind.
   */
  const DropdownMenu = ({ refProp, isMobile }) => {
    const items = [
      {
        icon: <FaUser className="text-[#5fbdb3] text-xs" />,
        label: "My Profile",
        to: "/profilepage",
        state: { scrollTo: "profile" },
        mobileAction: (e) =>
          handleDropdownClick(e, "/profilepage", { scrollTo: "profile" }),
      },
      {
        icon: <FaShoppingBag className="text-[#5fbdb3] text-xs" />,
        label: "My Orders",
        to: "/my-orders",
      },
      {
        icon: <FaPrescriptionBottleAlt className="text-[#5fbdb3] text-xs" />,

        label: "My Prescriptions",
        to: "/my-prescriptions",
      },
      {
        icon: <FaHistory className="text-[#5fbdb3] text-xs" />,
        label: "My Transactions",
        to: "/my-transactions",
      },
      {
        icon: <FaShoppingCart className="text-[#5fbdb3] text-xs" />,
        label: "My Cart",
        to: "/cart",
      },
      {
        icon: <FaHeart className="text-[#5fbdb3] text-xs" />,
        label: "My Wishlist",
        to: "/wishlist",
      },
    ];

    return (
      <div
        ref={refProp}
        className={`absolute ${
          isMobile ? "right-0 -mr-5" : "right-0"
        } top-full mt-2 w-56 bg-white rounded-2xl shadow-2xl border border-[#d4ecea] overflow-hidden z-50`}
      >
        {/* Header strip */}
        <div className="px-4 py-2.5 bg-[#eaf4f3] border-b border-[#d4ecea]">
          <p className="text-[10px] font-semibold uppercase tracking-widest text-[#3a7a74] font-poppins">
            My Account
          </p>
        </div>

        {items.map((item, i) =>
          isMobile && item.mobileAction ? (
            <div
              key={i}
              className="dropdown-link flex items-center gap-3 px-4 py-2.5 border-b border-[#f1f5f5] hover:bg-[#eaf4f3] cursor-pointer transition-colors duration-150"
              onClick={item.mobileAction}
            >
              <span className="w-4 flex-shrink-0 flex items-center justify-center">
                {item.icon}
              </span>
              <span className="text-[13px] font-medium text-[#374747] font-poppins">
                {item.label}
              </span>
            </div>
          ) : (
            <Link
              key={i}
              to={item.to}
              state={item.state}
              className="dropdown-link flex items-center gap-3 px-4 py-2.5 border-b border-[#f1f5f5] hover:bg-[#eaf4f3] transition-colors duration-150"
              onClick={() => setIsDropdownOpen(false)}
            >
              <span className="w-4 flex-shrink-0 flex items-center justify-center">
                {item.icon}
              </span>
              <span className="text-[13px] font-medium text-[#374747] font-poppins">
                {item.label}
              </span>
            </Link>
          ),
        )}

        {/* Logout */}
        <div
          className="flex items-center gap-3 px-4 py-2.5 hover:bg-red-50 cursor-pointer transition-colors duration-150"
          onClick={logoutUser}
        >
          <FaSignOutAlt className="text-red-400 w-4 flex-shrink-0" />
          <span className="text-[13px] font-medium text-red-500 font-poppins">
            Log Out
          </span>
        </div>
      </div>
    );
  };

  /* ────────────────────────────────────────────────────────────
     RENDER
  ──────────────────────────────────────────────────────────── */
  return (
    <nav>
      {/* ══════════════════════════════════════════════════
          DESKTOP  (lg and above)
      ══════════════════════════════════════════════════ */}
      <div className="hidden lg:block fixed top-0 left-0 right-0 z-[1000]">
        {/* Ticker */}
        <TickerBar />

        {/* Main bar */}
        <div className="bg-[#162c2a] h-[72px] flex items-center px-8 gap-4 shadow-[0_4px_24px_rgba(10,23,21,0.4)] border-b border-white/5">
          {/* Logo */}
          <a href="/home" className="flex-shrink-0 flex items-center">
            <img
              src={logo}
              alt="MediSYS"
              className="h-[50px] w-auto object-contain"
            />
          </a>

          {/* Separator */}
          <div className="w-px h-8 bg-white/10 flex-shrink-0" />

          {/* ── Search ── */}
          <div className="flex-1 max-w-[380px] relative">
            <div className="flex items-center gap-2.5 bg-white/[0.08] border border-white/[0.13] rounded-xl h-[44px] px-4 focus-within:bg-white/[0.14] focus-within:border-[#5fbdb3] focus-within:shadow-[0_0_0_3px_rgba(95,189,179,0.18)] transition-all duration-200">
              <svg
                width="15"
                height="15"
                viewBox="0 0 16 16"
                fill="none"
                className="flex-shrink-0 text-white/40"
              >
                <path
                  d="M7.4349 15.0989C9.30942 15.0989 11.022 14.4001 12.3305 13.2517L14.8651 15.59C14.9953 15.7097 15.1599 15.7704 15.3227 15.7704C15.5049 15.7704 15.6853 15.6982 15.8208 15.5522C16.0734 15.2776 16.0576 14.849 15.7821 14.5973L13.2633 12.2714C14.2674 11.0032 14.8694 9.40336 14.8694 7.66432C14.8694 3.56419 11.5348 0.229614 7.4347 0.229614C3.33458 0.229614 0 3.56419 0 7.66432C0 11.7644 3.33458 15.099 7.4347 15.099L7.4349 15.0989ZM7.4349 1.58126C10.7898 1.58126 13.5178 4.30934 13.5178 7.6642C13.5178 11.0191 10.7898 13.7471 7.4349 13.7471C4.08005 13.7471 1.35196 11.0191 1.35196 7.6642C1.35196 4.30934 4.08005 1.58126 7.4349 1.58126Z"
                  fill="currentColor"
                />
              </svg>
              <input
                type="text"
                value={query}
                onChange={handleInputChange}
                placeholder="Search medicines, products…"
                className="flex-1 bg-transparent border-none outline-none text-[13px] font-poppins text-white placeholder-white/35 min-w-0"
              />
              {query && (
                <button
                  onClick={() => {
                    setQuery("");
                    setShowResults(false);
                  }}
                  className="text-white/35 hover:text-white/70 text-xl leading-none flex-shrink-0 transition-colors"
                >
                  ×
                </button>
              )}
            </div>
            {showResults && <SearchDropdown isMobile={false} />}
          </div>

          {/* ── Upload Prescription ── */}
          <Link
            to="/my-prescriptions"
            onClick={handleUploadPrescriptionClick}
            className="group flex items-center gap-2 bg-white/[0.08] border border-white/[0.13] rounded-xl h-[44px] px-4 hover:bg-white/[0.16] hover:border-[#5fbdb3] transition-all duration-200 flex-shrink-0"
          >
            <svg width="18" height="18" viewBox="0 0 24 21" fill="none">
              <path
                d="M22.9414 10.4108C22.3555 10.4108 21.8826 10.8836 21.8826 11.4696V16.4317C21.8826 17.7828 20.781 18.8816 19.4327 18.8816H4.56762C3.21926 18.8816 2.11768 17.78 2.11768 16.4317V11.4696C2.11768 10.8836 1.6448 10.4108 1.05884 10.4108C0.472878 10.4108 0 10.8836 0 11.4696V16.4317C0 18.9492 2.05012 20.9992 4.56748 20.9992H19.4297C21.9499 20.9992 24 18.949 24 16.4317V11.4696C24 10.8836 23.5274 10.4108 22.9414 10.4108Z"
                fill="white"
              />
              <path
                d="M13.0578 3.61217L17.2504 7.80482C17.4558 8.01438 17.7275 8.1164 17.9991 8.1164C18.2706 8.1164 18.5423 8.01438 18.7477 7.80619C19.1613 7.39258 19.1613 6.72254 18.7477 6.3103L12.7476 0.310213C12.334 -0.103404 11.6639 -0.103404 11.2517 0.310213L5.25162 6.3103C4.838 6.72392 4.838 7.39395 5.25162 7.80619C5.66524 8.21981 6.33527 8.21981 6.74751 7.80619L10.9402 3.61213V14.4695C10.9402 15.0554 11.413 15.5283 11.999 15.5283C12.585 15.5283 13.0578 15.0554 13.0578 14.4695L13.0578 3.61217Z"
                fill="white"
              />
            </svg>

            <span className="text-[13px] font-medium font-poppins text-white/80 group-hover:text-white transition-colors whitespace-nowrap">
              Upload Prescription
            </span>
          </Link>

          {/* ── Right actions ── */}
          <div className="flex items-center gap-2 ml-auto flex-shrink-0">
            {/* Wishlist */}
            <div className="relative group">
              <button
                onClick={() => {
                  if (isLoggedIn) navigate("/wishlist");
                  else toast.error("Please log in before accessing wishlist");
                }}
                className="relative w-[44px] h-[44px] rounded-xl bg-white/[0.08] border border-white/[0.13] flex items-center justify-center text-white/70 hover:bg-white/[0.16] hover:border-[#5fbdb3] hover:text-white transition-all duration-200 hover:-translate-y-px"
              >
                <svg width="20" height="19" viewBox="0 0 24 22" fill="none">
                  <path
                    d="M6.38614 0C4.74261 0 3.09914 0.643735 1.85902 1.94157C-0.621273 4.5372 -0.618074 8.69647 1.85902 11.2938L11.3266 21.2228C11.4128 21.3132 11.5164 21.3852 11.6312 21.4344C11.7461 21.4836 11.8697 21.5089 11.9946 21.5089C12.1195 21.5089 12.2431 21.4836 12.358 21.4344C12.4728 21.3852 12.5765 21.3132 12.6626 21.2228C15.8209 17.9176 18.9815 14.6086 22.1398 11.3034C24.6201 8.70776 24.6201 4.54686 22.1398 1.95119C19.6596 -0.644474 15.5658 -0.644529 13.0856 1.95119L11.9994 3.07576L10.9133 1.94157C9.67315 0.643742 8.02968 0 6.38614 0Z"
                    fill="currentColor"
                  />
                </svg>
                {wishlistCount > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] bg-[#ff601e] text-white text-[9px] font-bold rounded-full flex items-center justify-center px-1 border-2 border-[#162c2a]">
                    {wishlistCount}
                  </span>
                )}
              </button>
              <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2.5 px-2.5 py-1 text-[10px] font-medium font-poppins text-white bg-[#1e4a46] rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                Wishlist
              </span>
            </div>

            {/* Cart */}
            <div className="relative group">
              <button
                onClick={() => {
                  if (isLoggedIn) navigate("/cart");
                  else toast.error("Please log in before accessing the cart.");
                }}
                className="relative w-[44px] h-[44px] rounded-xl bg-white/[0.08] border border-white/[0.13] flex items-center justify-center hover:bg-white/[0.16] hover:border-[#5fbdb3] transition-all duration-200 hover:-translate-y-px"
              >
                <img src={cart} alt="Cart" className="w-[22px] h-[22px]" />
                {cartCount > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] bg-[#ff601e] text-white text-[9px] font-bold rounded-full flex items-center justify-center px-1 border-2 border-[#162c2a]">
                    {cartCount}
                  </span>
                )}
              </button>
              <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2.5 px-2.5 py-1 text-[10px] font-medium font-poppins text-white bg-[#1e4a46] rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                Cart
              </span>
            </div>

            {/* Account / Login */}
            <div className="relative group">
              {isLoggedIn ? (
                <>
                  <button
                    onClick={(e) => {
                      if (!e.target.closest(".dropdown-link")) {
                        e.stopPropagation();
                        setIsDropdownOpen((p) => !p);
                      }
                    }}
                    className="w-[44px] h-[44px] rounded-xl bg-white/[0.08] border border-white/[0.13] flex items-center justify-center hover:bg-white/[0.16] hover:border-[#5fbdb3] transition-all duration-200 hover:-translate-y-px"
                  >
                    <img src={user} alt="User" className="w-[22px] h-[22px]" />
                  </button>
                  <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2.5 px-2.5 py-1 text-[10px] font-medium font-poppins text-white bg-[#1e4a46] rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                    My Account
                  </span>
                  {isDropdownOpen && (
                    <DropdownMenu
                      refProp={desktopDropdownRef}
                      isMobile={false}
                    />
                  )}
                </>
              ) : (
                <button
                  onClick={togglePopup}
                  className="flex items-center gap-2 h-[44px] px-5 bg-[#ff601e] hover:bg-[#e55519] rounded-xl text-white text-[13px] font-semibold font-poppins transition-all duration-200 hover:-translate-y-px shadow-[0_3px_14px_rgba(255,96,30,0.35)] hover:shadow-[0_6px_22px_rgba(255,96,30,0.45)] flex-shrink-0"
                >
                  <img
                    src={LoginUser}
                    alt="Login"
                    className="w-4 h-4 brightness-0 invert"
                  />
                  Login
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════
          MOBILE  (below lg)
      ══════════════════════════════════════════════════ */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-[#162c2a] shadow-[0_4px_20px_rgba(10,23,21,0.45)]">
        {/* Ticker */}
        <TickerBar />

        {/* Row 1 — Logo + icons + hamburger */}
        <div className="flex items-center justify-between px-4 py-2.5 border-b border-white/[0.08]">
          <a href="/home" className="flex-shrink-0">
            <img
              src={logo}
              alt="MediSYS"
              className="h-[42px] w-auto object-contain sm:h-[48px]"
            />
          </a>

          <div className="flex items-center gap-2">
            {/* Cart */}
            <button
              onClick={() => {
                if (isLoggedIn) navigate("/cart");
                else toast.error("Please log in before accessing the cart.");
              }}
              className="relative w-9 h-9 rounded-xl bg-white/[0.09] border border-white/[0.13] flex items-center justify-center hover:bg-white/[0.18] transition-colors"
            >
              <img src={cart} alt="Cart" className="w-5 h-5" />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 min-w-[15px] h-[15px] bg-[#ff601e] text-white text-[8px] font-bold rounded-full flex items-center justify-center px-0.5 border border-[#162c2a]">
                  {cartCount}
                </span>
              )}
            </button>

            {/* Account */}
            <div className="relative">
              {isLoggedIn ? (
                <>
                  <button
                    onClick={(e) => {
                      if (!e.target.closest(".dropdown-link")) {
                        e.stopPropagation();
                        toggleDropdown();
                      }
                    }}
                    className="w-9 h-9 rounded-xl bg-white/[0.09] border border-white/[0.13] flex items-center justify-center hover:bg-white/[0.18] transition-colors"
                  >
                    <img src={user} alt="User" className="w-5 h-5" />
                  </button>
                  {isDropdownOpen && (
                    <DropdownMenu refProp={mobileDropdownRef} isMobile={true} />
                  )}
                </>
              ) : (
                <button
                  onClick={togglePopup}
                  className="flex items-center gap-1.5 h-9 px-3 bg-[#ff601e] hover:bg-[#e55519] rounded-xl text-white text-[12px] font-semibold font-poppins transition-colors shadow-[0_2px_8px_rgba(255,96,30,0.35)]"
                >
                  <img
                    src={LoginUser}
                    alt="Login"
                    className="w-3 h-3 brightness-0 invert"
                  />
                  Login
                </button>
              )}
            </div>

            {/* Hamburger */}
            <button
              onClick={openSidebar}
              className="w-9 h-9 rounded-xl bg-white/[0.09] border border-white/[0.13] flex items-center justify-center hover:bg-white/[0.18] transition-colors"
            >
              <svg width="18" height="13" viewBox="0 0 18 13" fill="none">
                <rect y="0" width="18" height="2" rx="1" fill="white" />
                <rect y="5.5" width="13" height="2" rx="1" fill="white" />
                <rect y="11" width="9" height="2" rx="1" fill="white" />
              </svg>
            </button>
          </div>
        </div>

        {/* Row 2 — Search + Upload Rx + Quick Order */}
        <div className="flex items-center gap-2 px-4 py-2.5">
          {/* Search */}
          <div className="flex-1 relative">
            <div className="flex items-center gap-2 bg-white/[0.09] border border-white/[0.13] rounded-xl h-10 px-3 focus-within:bg-white/[0.16] focus-within:border-[#5fbdb3] focus-within:shadow-[0_0_0_2px_rgba(95,189,179,0.2)] transition-all duration-200">
              <svg
                width="14"
                height="14"
                viewBox="0 0 16 16"
                fill="none"
                className="text-white/35 flex-shrink-0"
              >
                <path
                  d="M7.4349 15.0989C9.30942 15.0989 11.022 14.4001 12.3305 13.2517L14.8651 15.59C14.9953 15.7097 15.1599 15.7704 15.3227 15.7704C15.5049 15.7704 15.6853 15.6982 15.8208 15.5522C16.0734 15.2776 16.0576 14.849 15.7821 14.5973L13.2633 12.2714C14.2674 11.0032 14.8694 9.40336 14.8694 7.66432C14.8694 3.56419 11.5348 0.229614 7.4347 0.229614C3.33458 0.229614 0 3.56419 0 7.66432C0 11.7644 3.33458 15.099 7.4347 15.099L7.4349 15.0989ZM7.4349 1.58126C10.7898 1.58126 13.5178 4.30934 13.5178 7.6642C13.5178 11.0191 10.7898 13.7471 7.4349 13.7471C4.08005 13.7471 1.35196 11.0191 1.35196 7.6642C1.35196 4.30934 4.08005 1.58126 7.4349 1.58126Z"
                  fill="currentColor"
                />
              </svg>
              <input
                type="text"
                value={query}
                onChange={handleInputChange}
                placeholder="Search medicines…"
                className="flex-1 bg-transparent border-none outline-none text-[13px] font-poppins text-white placeholder-white/35 min-w-0"
              />
              {query && (
                <button
                  onClick={() => {
                    setQuery("");
                    setShowResults(false);
                  }}
                  className="text-white/35 hover:text-white/70 text-xl leading-none flex-shrink-0 transition-colors"
                >
                  ×
                </button>
              )}
            </div>
            {showResults && <SearchDropdown isMobile={true} />}
          </div>

          {/* Upload Rx icon button */}
          <Link
            to="/my-prescriptions"
            onClick={handleUploadPrescriptionClick}
            className="flex-shrink-0 w-10 h-10 rounded-xl bg-white/[0.09] border border-white/[0.13] flex items-center justify-center hover:bg-white/[0.18] hover:border-[#5fbdb3] transition-all duration-200"
            title="Upload Prescription"
          >
            <svg width="18" height="18" viewBox="0 0 24 21" fill="none">
              <path
                d="M22.9414 10.4108C22.3555 10.4108 21.8826 10.8836 21.8826 11.4696V16.4317C21.8826 17.7828 20.781 18.8816 19.4327 18.8816H4.56762C3.21926 18.8816 2.11768 17.78 2.11768 16.4317V11.4696C2.11768 10.8836 1.6448 10.4108 1.05884 10.4108C0.472878 10.4108 0 10.8836 0 11.4696V16.4317C0 18.9492 2.05012 20.9992 4.56748 20.9992H19.4297C21.9499 20.9992 24 18.949 24 16.4317V11.4696C24 10.8836 23.5274 10.4108 22.9414 10.4108Z"
                fill="white"
              />
              <path
                d="M13.0578 3.61217L17.2504 7.80482C17.4558 8.01438 17.7275 8.1164 17.9991 8.1164C18.2706 8.1164 18.5423 8.01438 18.7477 7.80619C19.1613 7.39258 19.1613 6.72254 18.7477 6.3103L12.7476 0.310213C12.334 -0.103404 11.6639 -0.103404 11.2517 0.310213L5.25162 6.3103C4.838 6.72392 4.838 7.39395 5.25162 7.80619C5.66524 8.21981 6.33527 8.21981 6.74751 7.80619L10.9402 3.61213V14.4695C10.9402 15.0554 11.413 15.5283 11.999 15.5283C12.585 15.5283 13.0578 15.0554 13.0578 14.4695L13.0578 3.61217Z"
                fill="white"
              />
            </svg>
          </Link>

          {/* Quick Order — only when logged in */}
          {isLoggedIn && (
            <Link
              to="/my-orders"
              className="flex-shrink-0 h-10 px-3 bg-[#ff601e] hover:bg-[#e55519] rounded-xl text-white text-[11px] font-semibold font-poppins flex items-center transition-colors whitespace-nowrap shadow-[0_2px_8px_rgba(255,96,30,0.3)]"
            >
              Quick Order
            </Link>
          )}
        </div>
      </div>

      {/* ══════════════════════════════════════════════════
          POPUP
      ══════════════════════════════════════════════════ */}
      {isPopupOpen && <Popup onClose={togglePopup} />}

      {/* ══════════════════════════════════════════════════
          MOBILE SIDEBAR DRAWER
      ══════════════════════════════════════════════════ */}
      {isSidebarOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9998] lg:hidden"
            onClick={closeSidebar}
          />

          {/* Drawer panel */}
          <div className="fixed top-0 right-0 bottom-0 z-[9999] w-[72%] max-w-[300px] bg-[#162c2a] flex flex-col lg:hidden shadow-2xl">
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-4 border-b border-white/[0.08]">
              <img
                src={logo}
                alt="MediSYS"
                className="h-9 w-auto object-contain"
              />
              <button
                onClick={closeSidebar}
                className="w-8 h-8 rounded-xl bg-white/[0.09] border border-white/[0.13] flex items-center justify-center hover:bg-white/[0.18] transition-colors"
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M18 6L6 18M6 6l12 12"
                    stroke="white"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>

            {/* Nav list — sidebar-scroll = hide-scrollbar utility from global CSS */}
            <ul className="flex-1 overflow-y-auto sidebar-scroll py-3 px-3 space-y-0.5">
              {[
                { label: "Home", to: "/home" },
                { label: "About", to: "/about-us" },
                { label: "Categories", to: "/categories" },
                { label: "Featured", to: "/featured-products" },
                { label: "Brands", to: "/shopbrand" },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={closeSidebar}
                    className="flex items-center h-11 px-4 rounded-xl text-[14px] font-medium font-poppins text-white/75 hover:text-white hover:bg-white/[0.09] transition-all duration-150"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}

              {/* Concerns accordion */}
              <li>
                <button
                  type="button"
                  className="w-full flex items-center justify-between h-11 px-4 rounded-xl text-[14px] font-medium font-poppins text-white/75 hover:text-white hover:bg-white/[0.09] transition-all duration-150"
                  onClick={() => setShowConcerns((p) => !p)}
                >
                  <span>Concerns</span>
                  <svg
                    className={`transition-transform duration-200 ${showConcerns ? "rotate-90" : ""}`}
                    width="14"
                    height="14"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M6 12L10 8L6 4"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                {showConcerns && (
                  <ul className="ml-4 mt-1 pl-3 border-l border-white/[0.1] space-y-0.5">
                    {contextConcerns && contextConcerns.length > 0 ? (
                      contextConcerns.map((concern) => (
                        <li key={concern.concern_id}>
                          <button
                            className="w-full text-left text-[13px] font-normal font-poppins text-white/55 hover:text-white py-2 px-2 rounded-lg hover:bg-white/[0.07] transition-colors"
                            onClick={() => {
                              navigate(
                                `/shop-by-concern/${concern.name.toLowerCase().replace(/\s+/g, "-")}`,
                                {
                                  state: {
                                    concern_id: concern.concern_id,
                                    concern_name: concern.name,
                                  },
                                },
                              );
                              closeSidebar();
                              setShowConcerns(false);
                            }}
                          >
                            {concern.name}
                          </button>
                        </li>
                      ))
                    ) : (
                      <li className="text-[13px] text-white/35 py-2 px-2 font-poppins">
                        Loading…
                      </li>
                    )}
                  </ul>
                )}
              </li>

              {[
                { label: "All Products", to: "/products" },
                { label: "Wellness Guide", to: "/blogs" },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={closeSidebar}
                    className="flex items-center h-11 px-4 rounded-xl text-[14px] font-medium font-poppins text-white/75 hover:text-white hover:bg-white/[0.09] transition-all duration-150"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}

              {/* Wishlist */}
              <li>
                <button
                  className="w-full flex items-center justify-between h-11 px-4 rounded-xl text-[14px] font-medium font-poppins text-white/75 hover:text-white hover:bg-white/[0.09] transition-all duration-150"
                  onClick={() => {
                    if (isLoggedIn) {
                      navigate("/wishlist");
                      closeSidebar();
                    } else {
                      toast.error("Please log in before accessing wishlist");
                      closeSidebar();
                    }
                  }}
                >
                  <span>Wish List</span>
                  {wishlistCount > 0 && (
                    <span className="min-w-[20px] h-5 bg-[#ff601e] text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1">
                      {wishlistCount}
                    </span>
                  )}
                </button>
              </li>
            </ul>

            {/* Footer */}
            <div className="px-4 py-4 border-t border-white/[0.08]">
              {isLoggedIn ? (
                <button
                  onClick={() => {
                    logoutUser();
                    closeSidebar();
                  }}
                  className="w-full flex items-center justify-center gap-2 h-10 rounded-xl bg-white/[0.08] border border-white/[0.12] text-[13px] font-medium font-poppins text-white/75 hover:bg-red-500/20 hover:text-red-300 hover:border-red-400/30 transition-all duration-200"
                >
                  <FaSignOutAlt className="text-sm" />
                  Sign Out
                </button>
              ) : (
                <button
                  onClick={() => {
                    togglePopup();
                    closeSidebar();
                  }}
                  className="w-full flex items-center justify-center gap-2 h-10 rounded-xl bg-[#ff601e] hover:bg-[#e55519] text-[13px] font-semibold font-poppins text-white transition-colors shadow-[0_2px_10px_rgba(255,96,30,0.35)]"
                >
                  <img
                    src={LoginUser}
                    alt="Login"
                    className="w-3.5 h-3.5 brightness-0 invert"
                  />
                  Login / Sign Up
                </button>
              )}
            </div>
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar;
